import { memo } from 'react';
import { UserInput } from 'src/actuators/user-input/types';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { prepareUserInputFormValues } from 'src/actuators/common/prepareUserInputFormValues.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { JoinReactNodes } from 'src/common/JoinReactNodes.tsx';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    isLinear: boolean;
    currentLocale: LocalesEnum;
}

export const ActuatorTooltipValue = memo(({
    region,
    state,
    isLinear,
    currentLocale,
}: Props) => (
    <div className="vss-actuator-tooltip-value">
        {prepareUserInputFormValues({
            userInput: state,
            currentRegion: region,
            isLinear,
            currentLocale,
        }).map(([label, value, unit]) => {
            const valueArray = [
                typeof value === 'string' ? value : <I18n messageId={value.key}/>,
                typeof unit === 'string' ? '' : <I18n messageId={unit.key}/>,
            ];
            return (
                <div key={typeof label === 'string' ? label : label.key} className="vss-actuator-tooltip-value__row">
                    <p className="vss-actuator-tooltip-value__label">
                        {typeof label === 'string' ? label : <I18n messageId={label.key}/>}
                    </p>
                    <p className="vss-actuator-tooltip-value__value">
                        <JoinReactNodes separator=" " content={valueArray}/>
                    </p>
                </div>
            );
        })}
    </div>
));
